import { fromAnyIterable as r } from "../ponyfill/fromAnyIterable.js";
ReadableStream.from ??= r;
